const LIT = "#f3eecf";
const DARK = "#3a3f4b";
const RIM = "#8a8a8a";

const round = (value: number): number => Math.round(value * 100) / 100;

/**
 * The Moon's disc as seen from Earth: the lit part is the limb semicircle on the Sun's side
 * plus the half-ellipse of the terminator. `illumination` is 0–1. Seen from the northern
 * hemisphere a waxing Moon is lit on the right; from the southern hemisphere the picture
 * is turned half a circle, so the lit side is on the left.
 */
export function MoonDisc({
  illumination,
  waxing,
  southern = false,
  size,
}: {
  illumination: number;
  waxing: boolean;
  southern?: boolean;
  size: number;
}) {
  const r = 50;
  const lit = Math.min(1, Math.max(0, illumination));
  const rightSide = southern ? !waxing : waxing;
  const rx = round(Math.max(0.01, r * Math.abs(1 - 2 * lit)));
  const crescent = lit < 0.5;
  const limbSweep = rightSide ? 1 : 0;
  const terminatorSweep = crescent === rightSide ? 0 : 1;
  const path = `M50,0 A${r},${r} 0 0 ${limbSweep} 50,100 A${rx},${r} 0 0 ${terminatorSweep} 50,0 Z`;
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      height={size}
      viewBox="0 0 100 100"
      width={size}
    >
      <circle cx="50" cy="50" fill={DARK} r="50" stroke={RIM} strokeWidth="2" />
      {lit > 0.003 ? <path d={path} fill={LIT} /> : null}
    </svg>
  );
}
